define('DateCalculations.Moments', ['Moment'], function DateCalculationsMoments(moment) {
  'use strict';

  return {
    /**
     * @param {Object|null} timeData
     * @param {String} timeData.time
     * @param {String|null} timeData.timeZone
     * @returns {Moment|null}
     */
    getMomentForTimeToday: function getMomentForTimeToday(timeData) {
      var now;
      var momentForTime;
      if (!timeData || !timeData.time) {
        return null;
      }
      now = moment();
      momentForTime = this.getMomentForTime(timeData);
      return momentForTime.year(now.year()).month(now.month()).date(now.date());
    },

    /**
     * @param {Object|null} timeData
     * @param {String} timeData.time
     * @param {String|null} timeData.timeZone
     * @returns {Moment|null}
     */
    getMomentForTimeTodayTomorrow: function getMomentForTimeToday(timeData) {
      var momentForTimeToday;
      if (!timeData || !timeData.time) {
        return null;
      }
      momentForTimeToday = this.getMomentForTimeToday(timeData);
      return momentForTimeToday.add(1, 'days');
    },

    /**
     * @param {Object|null} timeData
     * @param {String} timeData.time
     * @param {String|null} timeData.timeZone
     * @returns {Moment|null}
     */
    getMomentForTime: function getMomentForTime(timeData) {
      var format = 'h:m a';
      var time;
      var timeZone;
      if (!timeData || !timeData.time) {
        return null;
      }
      time = timeData.time;
      timeZone = timeData.timeZone;
      return timeZone && moment(time, format);
    }
  };
});
